import { render, staticRenderFns } from "./Entitites.vue?vue&type=template&id=ed18ab04"
import script from "./Entitites.vue?vue&type=script&lang=js"
export * from "./Entitites.vue?vue&type=script&lang=js"
import style0 from "./Entitites.vue?vue&type=style&index=0&id=ed18ab04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports